import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {StockLevelSearchModel} from "../stock-level-search.model";
import {StockLevelEntityModel} from "../stock-level-entity.model";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-stock-level-search-page",
    templateUrl: "./stock-level-search-page.component.html",
    providers: [provideSearchModel(StockLevelSearchModel), provideEntityModel(StockLevelEntityModel)]
})

export class StockLevelSearchPageComponent extends AbstractSearchPage {
    constructor() {
        super();
    }
}
